import { memo } from 'react';
import { useSelector } from '@xstate/store/react';
import { WAYPOINT_RADIUS } from '../../types';
import type { CanvasEntity } from '../../entityTypes';
import { useMergedDropTarget } from '../../hooks/useMergedDropTarget';
import { canvasSelectionStore } from '../../stores/canvasSelectionStore';

export interface CanvasWaypointNodeProps {
  entity: CanvasEntity;
}

const D = WAYPOINT_RADIUS * 2;

function CanvasWaypointNodeInner({ entity }: CanvasWaypointNodeProps) {
  const { mergedDropTargetId } = useMergedDropTarget();

  const isSelected = useSelector(canvasSelectionStore, s => s.context.selectedEntityIds.includes(entity.id));
  const isDropTarget = mergedDropTargetId === entity.id;

  let borderColor = '#9ca3af';
  let bgColor = 'white';
  let ringClass = '';
  let scaleClass = '';

  if (isDropTarget) {
    borderColor = '#22c55e';
    bgColor = '#f0fdf4';
    ringClass = 'ring-2 ring-green-400';
    scaleClass = 'scale-125';
  } else if (isSelected) {
    borderColor = '#3b82f6';
    bgColor = '#eff6ff';
    ringClass = 'ring-2 ring-blue-400';
  }

  return (
    <div
      data-canvas-entity
      data-canvas-waypoint={entity.id}
      data-entity-id={entity.id}
      data-entity-kind={entity.kind}
      style={{
        position: 'absolute',
        left: entity.x - WAYPOINT_RADIUS,
        top: entity.y - WAYPOINT_RADIUS,
        width: D,
        height: D,
        borderRadius: '50%',
        border: `2px solid ${borderColor}`,
        backgroundColor: bgColor,
        cursor: 'pointer',
        transition: 'transform 0.1s, border-color 0.15s, background-color 0.15s',
      }}
      className={`${ringClass} ${scaleClass}`}
    />
  );
}

export const CanvasWaypointNode = memo(CanvasWaypointNodeInner);
